import { FilterColumn } from "types";
import { onlyDigits } from "validators";

const appIdColumn = ({
	name = "number",
	placeholder = "App ID",
} = {}): FilterColumn => ({
	name,
	type: "input" as const,
	placeholder,
	normalize: onlyDigits,
});

export default appIdColumn;
